<template>
  <div class="card py-2 px-3 mb-1">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div style="font-weight: 600">{{ template.name }}</div>
        <div>
          <span class="mr-2" style="text-transform: capitalize"
            >Subject: {{ template.subject }}</span
          >
          Year Level: {{ template.yearLevel || "Prep" }}
        </div>
      </div>
      <div v-if="deleted === false">
        <a
          href="javascript:;"
          @click="$emit('duplicate', template)"
          class="mr-3"
          style="font-weight: 600"
          >DUPLICATE</a
        >
        <a
          :href="'/dashboard/templates/add?id=' + template._id"
          style="font-weight: 600"
          >EDIT</a
        >
        <a
          href="#"
          @click="deleteTemplate()"
          class="ml-3"
          style="font-weight: 600"
          >DELETE</a
        >
      </div>
      <div v-if="deleted === true">DELETED</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["template"],
  data() {
    return {
      deleted: false,
    };
  },
  methods: {
    deleteTemplate() {
      this.axios
        .delete(
          `${process.env.VUE_APP_API_URL}/api/templates/${this.template._id}`
        )
        .then((res) => {
          this.deleted = true;
          this.$root.$emit("popup", "Template successfully deleted.");
        });
    },
  },
};
</script>
